import * as React from 'react'
import { Link } from 'react-router-dom'

import { Box, Icon, tokens, useClassNames, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Logo from 'modules/core/components/Logo'
import Popover from 'modules/core/components/Popover'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import companies from 'modules/core/store/collections/companies'

import { hasOnboardingEnabled } from 'modules/employee_onboarding/lib/utils'
import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'

import CompanySelector from './CompanySelector'
import * as styles from './index.vanilla.css'

type Props = {
  isAdminBecome: boolean
  onChoose: () => void
}

export function navigateRoot() {
  window.location.href = window.location.origin
}

function CompanySwitcher({ isAdminBecome, onChoose }: Props) {
  const [open, toggle] = useToggle()
  const cx = useClassNames(styles)
  const { navigation } = useNavigation()
  const { employee, company } = useCurrentSession()
  const linkPath = () => {
    if (!hasRegularAccessOrNotEmployee(employee)) {
      return hasOnboardingEnabled() ? navigation.employee_onboarding.path : navigation.profile.path
    }
    return navigation.dashboard.path
  }

  if (companies.models.length === 1 || isAdminBecome) {
    return (
      <Box flexDirection="column" alignItems="flexStart" paddingY="s16" paddingX="s12" gap="s8">
        <Link to={linkPath()}>
          <div className={styles.logo} role="img" aria-label="Logo">
            <Logo companyLogo={company.logo} alt={company.name} />
          </div>
        </Link>
      </Box>
    )
  }

  return (
    <Popover
      attachment="top left"
      open={open}
      size="huge"
      targetAttachment="bottom left"
      toggle={toggle}
      offset={`0 -${tokens.dimensions.s32}`}
    >
      <div className={styles.wrapper}>
        <div className={styles.logo} role="img" aria-label="Logo">
          <Logo companyLogo={company.logo} alt={company.name} />
        </div>
        <div className={cx('icon')}>
          <Icon.Small icon="caret-double" color="sidebarIconSecondary" />
        </div>
      </div>
      <CompanySelector onChoose={onChoose} />
    </Popover>
  )
}

export default observer(CompanySwitcher)
